import { useCallback, useEffect, useState } from "react";

import { useSubscribe } from "data/messages/hooks";

function useSubscribeToAddNewAssigner({ onCompleted, onCancelled }) {
  const [newUsers, setNewUsers] = useState(null);
  const [isCancelled, setCancelled] = useState(false);

  useEffect(() => {
    if (newUsers) {
      onCompleted(newUsers);
      setNewUsers(null);
    }
  }, [newUsers, onCompleted]);

  useEffect(() => {
    if (isCancelled) {
      onCancelled();
      setCancelled(false);
    }
  }, [isCancelled, onCancelled]);

  useSubscribe(
    "addUserCompleted",
    useCallback((users) => {
      if (users.size > 0) setNewUsers([...users]);
    }, [])
  );

  useSubscribe(
    "addUserCancelled",
    useCallback((cancelledSet) => {
      if (cancelledSet && cancelledSet.values().next().value)
        setCancelled(true);
    }, [])
  );
}

export default useSubscribeToAddNewAssigner;
